import { Pair } from "../types/tuple"

export default <T extends Object>(object: T): ReadonlyArray<Pair<keyof T, T[keyof T]>> => Object.entries(object) as Array<[keyof T, T[keyof T]]>
